'use client';

import {
	createContext, PropsWithChildren, useContext,
} from 'react';

import type { FormConfig, FormConfigProviderProps } from './FormConfigProvider.types';

const defaultFormConfig: FormConfig = {
	disableSubmit: {
		onLoading:      true,
		onSubmitting:   true,
		whenIsNotDirty: false,
		whenNotValid:   false,
	},
};

export const FormConfigContext = createContext<FormConfig>(defaultFormConfig);

export const useFormConfig = () => useContext(FormConfigContext);

export const FormConfigProvider = ({
	children,
	formConfig,
}: PropsWithChildren<FormConfigProviderProps>) => {
	const mergedConfig: FormConfig = {
		...defaultFormConfig,
		...formConfig,
		disableSubmit: {
			...defaultFormConfig.disableSubmit,
			...formConfig?.disableSubmit,
		},
	};

	return (
		<FormConfigContext.Provider value={mergedConfig}>
			{children}
		</FormConfigContext.Provider>
	);
};
